/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const EnduranceRbacRolesEnums = {
    PUT_ROLE_EDIT: (roleId: string): string => {
        return `/rbac/roles/${roleId}`;
    },
    POST_ROLES_ADD: '/rbac/roles',
    DELETE_ROLE_ID: (roleId: string): string => {
        return `/rbac/roles/${roleId}`;
    },
    GET_ROLES_ALL: '/rbac/roles',
    GET_ROLE_ID: (roleId: string): string => {
        return `/rbac/roles/${roleId}`;
    }
};
